<template>
  <div id="video-view" class="video-view">
    <van-popup v-model="show" :close-on-click-overlay="false">
      <div class="videoBox">
        <a class="btn-close" @click="closeVideo"></a>
        <div class="video-box" v-html="videoHtml"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Pay from '@/components/pay'
export default {
  name: 'video-view',
  components: {Pay},
  props: {
    show: false,
    videoUrl: ''
  },
  data () {
    return {
      videoHtml: ''
    }
  },
  methods: {
    closeVideo: function () {
      this.videoHtml = ''
      this.$emit('closeVideo')
    }
  },
  watch: {
    videoUrl: function (val) {
      if (val.length > 0) {
        console.log('检测视频===================')
        this.videoUrl = val
        this.videoHtml = '<video autoplay="autoplay" controls="controls" width="100%" height="100%" loop="loop" preload="auto" src=' + this.videoUrl + '></video>'
      }
    }
  },
  mounted () {
    if (parseInt(this.type) === 1) {
    }
  }
}
</script>

<style scoped>
  .videoBox{
    width: 380px;
    height: 250px;
    background-color: #000000;
  }
  .video-box {
    position:absolute;
    top:30px;
    width: 360px;
    height: 200px;
    left: calc(50% + 10px);
    margin-left: -50%;
    /*background-color:yellow;*/
  }
  .btn-close {
    width: 28px;
    height: 28px;
    display: block;
    position: absolute;
    top: 0px;
    right: 0;
    background-color: yellowgreen;
    background: url(../assets/icon-close.png) no-repeat;
    background-size:cover;
    z-index:10011;
  }
</style>



// WEBPACK FOOTER //
// src/components/video-view.vue